import cn from 'classnames/bind'

import Avatar from 'app/common/ui/Avatar'
import OveflowedText from 'app/common/components/OveflowedText'
import { SenderUID, RecipientUID } from 'app/dataTypes/transfer/uid'

import styles from './DropdownItem.module.scss';


const cx = cn.bind(styles)

export type DropdownItemProps = {
  id: SenderUID | RecipientUID // eslint-disable-line react/no-unused-prop-types
  title: string
  balance: string
  photo: string | null
  gender: string
  selected?: boolean // eslint-disable-line react/no-unused-prop-types
  disabled?: boolean
}

export const DropdownItem = ({ title, balance, photo, gender, disabled }: DropdownItemProps) => (
  <span className={cx(styles.root, { disabled })}>
    <Avatar gender={gender} src={photo || ''} className={styles.avatar} />
    <OveflowedText className={styles.title}>{title}</OveflowedText>
    <OveflowedText className={styles.balance}>{balance}</OveflowedText>
  </span>
)
